"use strict";
/*
 * TrackingEvent is the type of the payload of a
 * custom event coming from a Studio Creative
 *
 * eC: Event Category
 * eA: Event Action
 * eL: Event Label
 * eV: Event Value
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VASTActions = void 0;
/*
 * VASTActions is the list of valid video events
 * coming from a Studio Creative
 */
var VASTActions;
(function (VASTActions) {
    VASTActions["START"] = "start";
    VASTActions["FIRST_QUARTILE"] = "firstQuartile";
    VASTActions["MIDPOINT"] = "midpoint";
    VASTActions["THIRD_QUARTILE"] = "thirdQuartile";
    VASTActions["COMPLETE"] = "complete";
    VASTActions["MUTE"] = "mute";
    VASTActions["UNMUTE"] = "unmute";
    VASTActions["PAUSE"] = "pause";
    VASTActions["RESUME"] = "resume";
})(VASTActions = exports.VASTActions || (exports.VASTActions = {}));
//# sourceMappingURL=studio-creative.types.js.map